import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { ConnectionDetailsSection } from './components/ConnectionDetailsSection';
import { IntegrationDetailHeader } from './components/IntegrationDetailHeader';
import { SettingsCard } from './components/SettingsCard';
import { integrationsStateLoadable } from './state/IntegrationsState';
import { AppMap } from './utils/uiAppData';
import { useAtomValue } from 'jotai';

interface IIntegrationDetailProps {
  /** Overrides the `:appName` route param — used when this is rendered directly
   *  (e.g. by CartaConfiguration for a not-yet-eligible Carta app) rather than via
   *  the generic `:appName` fallback route. */
  routeKey?: string;
}

export function IntegrationDetail({ routeKey: routeKeyOverride }: IIntegrationDetailProps = {}) {
  const { appName: routeKeyParam } = useParams<{ appName: string }>();
  const routeKey = routeKeyOverride ?? routeKeyParam;
  const integrationsLoadable = useAtomValue(integrationsStateLoadable);
  const integrationsData = integrationsLoadable.state === 'hasData' ? integrationsLoadable.data : undefined;

  const appEntry = useMemo(
    () => integrationsData?.find((app) => AppMap.get(app.appName)?.routeKey === routeKey),
    [integrationsData, routeKey]
  );

  const uiData = appEntry ? AppMap.get(appEntry.appName) : null;

  if (!uiData || !appEntry) {
    return null;
  }

  return (
    <Stack width='100%' height='100%' padding='8px 12px 12px' gap='1rem' overflow='auto'>
      <IntegrationDetailHeader appName={appEntry.appName} description={uiData.description} />
      {appEntry.isConnected && (
        <SettingsCard>
          <ConnectionDetailsSection isConnected />
        </SettingsCard>
      )}
    </Stack>
  );
}
